export default () => {
  return [
    {
      imgUrl: require("@/assets/images/resolve/5.png"),
      title: "AI大模型聚合API平台",
      content: "开箱即用的大模型 API，覆盖语言、语音、图片、视频等场景，一站式提供大模型 API 服务，按量计费，助力应用快速上线。提供企业级私有化部署方案，满足多样化场景需求。",
      url: "https://aiapi.fintechgp.com",
    },
    {
      imgUrl: require("@/assets/images/resolve/7.png"),
      title: "AI智能体平台",
      content: "AI 智能体平台专业构建企业级AI智能体，支撑 AI 应用全流程快速落地。基于企业知识库，开发专属AI应用软件，支持多种AI框架和算法，满足不同场景需求，提高工作效率，减少人工成本。",
      url: "https://agent.fintechgp.com",
    },
    {
      imgUrl: require("@/assets/images/resolve/1.png"),
      title: "公共资源交易(招采交易平台)",
      content: "结合我国招标投标的实际情况，遵循国家《电子招标投标办法》，按照其技术规范和相关行业技术标准，面向招标人（招标代理机构）、投标人、评委、监督部门、运营机构及公众，满足各行业的招标投标需求，建立起公共服务平台、交易平台、行政监督平台等三大围绕电子招标投标业务的系统，帮助各交易主体解决电子招标、投标、开标、评标等招标投标全过程业务，实现所有招标项目全过程电子化、网络化、智能化。",
    },
    {
      imgUrl: require("@/assets/images/resolve/2.png"),
      title: "电子账户",
      content: "涉及进行会员、账户进行管理的应用场景都需要有电子账户进行支撑。部分第三方支付公司和金融机构对互金企业提供账户体系输出。",
    },
    {
      imgUrl: require("@/assets/images/resolve/3.png"),
      title: "聚合支付",
      content: "金融业务应用中，往往涉及资金支付需求。整个支付生态链由消费场景、第三方支付公司、银行结算账户、人行清算系统组成，我们侧重在消费场景聚合支付及第三方支付公司系统架构上。",
    },
    {
      imgUrl: require("@/assets/images/resolve/4.png"),
      title: "聚合征信",
      content: "金融的核心是信用定价。互联网金融一般采用人员细分、服务场景化，以及通过对第三方征信的聚合进行有效风险管理。",
    },
    {
      imgUrl: require("@/assets/images/resolve/5.png"),
      title: "消费金融",
      content: "消费金融以消费场景为切入口，通过分期、白条等方式提供金融服务，可以有效促进消费，并产生金融利差利润。",
    },
    {
      imgUrl: require("@/assets/images/resolve/6.png"),
      title: "融资租赁",
      content: "融资租赁将成为“仅次于银行信贷的第二大融资方式”。汽车融资租赁业务是汽车金融很重要一环，也是网络借贷中优质资产的提供方。",
    },
    {
      imgUrl: require("@/assets/images/resolve/7.png"),
      title: "大数据",
      content: "多家行业头部企业和政府客户，提供了数据中台建设和数据资产开发服务。",
    },
  ];
};
